const decisionIndex = (state = "1", action) => {
  return state;
}

export default decisionIndex;